/*
  De La Terre · Collection / PLP Runtime v1
  P1.10 · 31/08/2026
  Externalized from dlt-collection-grid-premium.liquid without changing filter, sort, wishlist or cart semantics.
*/
(function () {
  'use strict';

  if (window.DLTCollectionGridRuntime) return;

  function init(root) {
    if (!root) return;

  var section = root.querySelector('[data-dlt-grid-section]');
  if (!section || section.dataset.dltGridReady === 'true') return;
  section.dataset.dltGridReady = 'true';

  var grid = root.querySelector('[data-dlt-grid-products]');
  if (!grid) return;

  var controller = new AbortController();
  var signal = controller.signal;
  root.__dltGridAbortController = controller;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-dlt-grid-item]'));
  var originalOrder = items.slice();
  var itemDataCache = new WeakMap();
  var filterControls = Array.prototype.slice.call(root.querySelectorAll('[data-dlt-filter-group]'));
  var countControls = Array.prototype.slice.call(root.querySelectorAll('[data-dlt-count-for]'));
  var wishlistButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dlt-wishlist]'));
  var countEls = Array.prototype.slice.call(root.querySelectorAll('[data-dlt-grid-count], [data-dlt-grid-panel-count]'));
  var emptyEl = root.querySelector('[data-dlt-grid-empty]');
  var filterButton = root.querySelector('[data-dlt-grid-filter-button]');
  var floatingButton = root.querySelector('[data-dlt-grid-floating-filter]');
  var floatingCount = root.querySelector('[data-dlt-grid-floating-count]');
  var backdrop = root.querySelector('[data-dlt-grid-backdrop]');
  var panel = root.querySelector('[data-dlt-grid-panel]');
  var panelClose = root.querySelector('[data-dlt-grid-panel-close]');
  var applyButton = root.querySelector('[data-dlt-grid-apply]');
  var clearButton = root.querySelector('[data-dlt-grid-clear]');
  var activePills = root.querySelector('[data-dlt-grid-active-pills]');
  var sortSelects = Array.prototype.slice.call(root.querySelectorAll('[data-dlt-grid-sort], [data-dlt-grid-sort-mobile]'));
  var wishlistKey = 'dlt-wishlist';
  var lockClass = 'dlt-grid-filter-lock';
  var tooltipLayer = root.querySelector('[data-dlt-grid-tooltip-layer]');
  var tooltipTimer = null;
  var activeTooltipTrigger = null;
  var renderFrame = 0;
  var resizeFrame = 0;
  var pendingRenderUpdateUrl = false;
  var orderedItemsCache = null;
  var orderedItemsSortValue = null;
  var domOrderSortValue = null;
  var countIdleHandle = 0;
  var mobileMedia = window.matchMedia('(max-width: 749px)');

  var filters = {
    active: [],
    skin: [],
    price: null,
    availability: null
  };

  /*
    DLT v38 · ordenação robusta
    Mantém um estado único de ordenação para desktop/mobile e sincroniza com sort_by nativo.
    Isso evita que selects ocultos/off-canvas sejam lidos como ativos e façam a opção "Menor preço" parecer não responder.
  */
  var currentSortValue = 'popular';

  var nativeToDltSortMap = {
    'manual': 'popular',
    'best-selling': 'popular',
    'price-ascending': 'price-asc',
    'price-descending': 'price-desc',
    'title-ascending': 'az'
  };

  var dltToNativeSortMap = {
    'popular': '',
    'price-asc': 'price-ascending',
    'price-desc': 'price-descending',
    'discount': '',
    'az': 'title-ascending'
  };

  function normalizeSortValue(value) {
    if (!value) return 'popular';

    value = String(value);

    if (nativeToDltSortMap[value]) {
      return nativeToDltSortMap[value];
    }

    if (value === 'price-asc' || value === 'price-desc' || value === 'discount' || value === 'az' || value === 'popular') {
      return value;
    }

    return 'popular';
  }

  function isMobile() {
    return mobileMedia.matches;
  }

  /*
    DLT P1.8.1 — PLP secondary media on demand.
    The second product image is intentionally emitted without src/srcset so
    mobile and non-interacted cards do not download an image used only for hover.
  */
  function hydrateHoverImage(image) {
    if (!image || image.dataset.dltHoverLoaded === 'true') return;

    var src = image.getAttribute('data-src');
    var srcset = image.getAttribute('data-srcset');
    if (!src && !srcset) return;

    image.dataset.dltHoverLoaded = 'true';

    if (srcset) image.setAttribute('srcset', srcset);
    if (src) image.setAttribute('src', src);

    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
  }

  function hydrateCardHoverMedia(target) {
    if (isMobile() || !target || !target.closest) return;

    var card = target.closest('.dlt-card');
    if (!card || !root.contains(card)) return;

    hydrateHoverImage(card.querySelector('[data-dlt-card-hover-image]'));
  }

  function getItemData(item) {
    var cached = itemDataCache.get(item);
    if (cached) return cached;

    cached = {
      available: item.getAttribute('data-available') === 'true',
      onSale: item.getAttribute('data-on-sale') === 'true',
      active: new Set((item.getAttribute('data-active') || '').split(' ').filter(Boolean)),
      skin: new Set((item.getAttribute('data-skin') || '').split(' ').filter(Boolean)),
      price: parseInt(item.getAttribute('data-price'), 10) || 0,
      discount: parseInt(item.getAttribute('data-discount'), 10) || 0,
      title: item.getAttribute('data-title') || ''
    };

    itemDataCache.set(item, cached);
    return cached;
  }

  function clearTooltipTimer() {
    if (!tooltipTimer) return;
    window.clearTimeout(tooltipTimer);
    tooltipTimer = null;
  }

  function positionTooltip(trigger) {
    if (!tooltipLayer || !trigger) return;

    var rect = trigger.getBoundingClientRect();
    var layerRect = tooltipLayer.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var edge = isMobile() ? 8 : 12;
    var margin = isMobile() ? 8 : 10;

    var left = rect.left + (rect.width / 2) - (layerRect.width / 2);
    var top = rect.top - layerRect.height - margin;

    if (top < edge) {
      top = rect.bottom + margin;
    }

    if (top + layerRect.height > viewportHeight - edge) {
      top = Math.max(edge, viewportHeight - layerRect.height - edge);
    }

    left = Math.max(
      edge,
      Math.min(left, viewportWidth - layerRect.width - edge)
    );

    tooltipLayer.style.left = Math.round(left) + 'px';
    tooltipLayer.style.top = Math.round(top) + 'px';
  }

  function hideTooltip(delay) {
    clearTooltipTimer();
    if (!tooltipLayer) return;

    var hideNow = function () {
      tooltipLayer.classList.remove('is-visible');
      tooltipLayer.setAttribute('aria-hidden', 'true');
      activeTooltipTrigger = null;
    };

    var wait = typeof delay === 'number' ? delay : 0;
    if (wait <= 0) {
      hideNow();
      return;
    }

    tooltipTimer = window.setTimeout(hideNow, wait);
  }

  function showTooltip(trigger) {
    if (!tooltipLayer || !trigger) return;

    var content = trigger.getAttribute('data-dlt-grid-tooltip');
    if (!content) return;

    clearTooltipTimer();
    activeTooltipTrigger = trigger;
    tooltipLayer.textContent = content;
    tooltipLayer.setAttribute('aria-hidden', 'false');
    tooltipLayer.classList.add('is-visible');

    window.requestAnimationFrame(function () {
      positionTooltip(trigger);
    });

    if (isMobile()) {
      hideTooltip(4200);
    }
  }

  function getTooltipTrigger(target) {
    if (!target || !target.closest) return null;

    var trigger = target.closest('[data-dlt-grid-tooltip]');
    return trigger && root.contains(trigger) ? trigger : null;
  }

  function enteredOrLeftTrigger(trigger, relatedTarget) {
    return !relatedTarget || !trigger.contains(relatedTarget);
  }

  /*
    DLT P1.10 — tooltip + hover-media delegation.
    Cards can expose up to three tooltip triggers each. The previous runtime
    installed five listeners per trigger. We keep the same interaction model
    with four delegated listeners on the collection root and reuse the existing
    delegated click handler for touch.
  */
  root.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'touch') {
      hydrateCardHoverMedia(event.target);
    }

    if (event.pointerType === 'touch') return;

    var trigger = getTooltipTrigger(event.target);
    if (!trigger || !enteredOrLeftTrigger(trigger, event.relatedTarget)) return;

    showTooltip(trigger);
  }, { passive: true, signal: signal });

  root.addEventListener('pointerout', function (event) {
    if (event.pointerType === 'touch') return;

    var trigger = getTooltipTrigger(event.target);
    if (!trigger || !enteredOrLeftTrigger(trigger, event.relatedTarget)) return;

    hideTooltip(100);
  }, { passive: true, signal: signal });

  root.addEventListener('focusin', function (event) {
    hydrateCardHoverMedia(event.target);

    var trigger = getTooltipTrigger(event.target);
    if (trigger) showTooltip(trigger);
  }, { signal: signal });

  root.addEventListener('focusout', function (event) {
    var trigger = getTooltipTrigger(event.target);
    if (!trigger || !enteredOrLeftTrigger(trigger, event.relatedTarget)) return;

    hideTooltip(80);
  }, { signal: signal });

  function uniqueList(value) {
    if (!value) return [];

    return String(value)
      .split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean)
      .filter(function (item, index, list) { return list.indexOf(item) === index; });
  }

  function getParams() {
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (error) {
      return null;
    }
  }

  function hydrateFromUrl() {
    var params = getParams();
    if (!params) return;

    filters.active = uniqueList(params.get('dlt_active'));
    filters.skin = uniqueList(params.get('dlt_skin'));
    filters.price = params.get('dlt_price') || null;
    filters.availability = params.get('dlt_availability') || null;

    var nativeSortValue = params.get('sort_by') || '';
    var sortValue = params.get('dlt_sort') || nativeToDltSortMap[nativeSortValue] || '';

    if (sortValue || nativeSortValue) {
      setSortValue(sortValue || nativeSortValue, false);
    }
  }

  function updateUrlState() {
    if (!window.history || !window.history.replaceState) return;

    var params = getParams();
    if (!params) return;

    if (filters.active.length) {
      params.set('dlt_active', filters.active.join(','));
    } else {
      params.delete('dlt_active');
    }

    if (filters.skin.length) {
      params.set('dlt_skin', filters.skin.join(','));
    } else {
      params.delete('dlt_skin');
    }

    if (filters.price) {
      params.set('dlt_price', filters.price);
    } else {
      params.delete('dlt_price');
    }

    if (filters.availability) {
      params.set('dlt_availability', filters.availability);
    } else {
      params.delete('dlt_availability');
    }

    var sortValue = normalizeSortValue(getSortValue());
    var nativeSortValue = dltToNativeSortMap[sortValue] || '';

    if (sortValue && sortValue !== 'popular') {
      params.set('dlt_sort', sortValue);
    } else {
      params.delete('dlt_sort');
    }

    if (nativeSortValue) {
      params.set('sort_by', nativeSortValue);
    } else {
      params.delete('sort_by');
    }

    params.delete('page');

    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;

    window.history.replaceState({}, '', nextUrl);
  }

  function readWishlist() {
    try {
      var items = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    localStorage.setItem(wishlistKey, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('dlt:wishlist-updated'));
  }

  function syncWishlist() {
    var wishlist = readWishlist();
    var tokens = new Set();

    wishlist.forEach(function (item) {
      if (typeof item === 'string' || typeof item === 'number') {
        tokens.add(String(item));
        return;
      }

      if (!item) return;
      if (item.id != null) tokens.add(String(item.id));
      if (item.handle != null) tokens.add(String(item.handle));
    });

    wishlistButtons.forEach(function (button) {
      var productId = String(button.getAttribute('data-product-id') || '');
      var handle = String(button.getAttribute('data-product-handle') || '');
      var active = tokens.has(productId) || tokens.has(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Salvar nos favoritos');
    });
  }

  function toggleWishlist(button) {
    var productId = String(button.getAttribute('data-product-id') || '');
    var handle = String(button.getAttribute('data-product-handle') || '');
    if (!productId && !handle) return;

    var wishlist = readWishlist();
    var exists = wishlist.some(function (item) {
      if (typeof item === 'string' || typeof item === 'number') {
        return String(item) === productId || String(item) === handle;
      }

      return item && (String(item.id) === productId || String(item.handle) === handle);
    });

    if (exists) {
      wishlist = wishlist.filter(function (item) {
        if (typeof item === 'string' || typeof item === 'number') {
          return String(item) !== productId && String(item) !== handle;
        }

        return !item || (String(item.id) !== productId && String(item.handle) !== handle);
      });
    } else {
      wishlist.push({ id: productId, handle: handle });
    }

    // writeWishlist dispatches dlt:wishlist-updated synchronously; the
    // delegated window listener below performs the single UI sync.
    writeWishlist(wishlist);
  }

  function setButtonState(button, state) {
    if (!button) return;

    button.classList.remove('is-loading', 'is-added', 'is-error');

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else if (state === 'added') {
      button.classList.add('is-added');
      button.disabled = true;
      button.removeAttribute('aria-busy');
    } else if (state === 'error') {
      button.classList.add('is-error');
      button.disabled = false;
      button.removeAttribute('aria-busy');
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function refreshCartEvents(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    window.dispatchEvent(new CustomEvent('cart-update', { detail: { cart: cart } }));
    window.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    var productUrl = button.getAttribute('data-product-url');
    var hasOptions = button.getAttribute('data-has-options') === 'true';

    if (hasOptions) {
      window.location.href = productUrl + (variantId ? '?variant=' + encodeURIComponent(variantId) : '');
      return;
    }

    if (!variantId || button.disabled) return;

    setButtonState(button, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Erro ao adicionar');
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        setButtonState(button, 'added');
        refreshCartEvents(cart);

        setTimeout(function () {
          setButtonState(button, 'default');
        }, 1500);
      })
      .catch(function () {
        setButtonState(button, 'error');

        setTimeout(function () {
          setButtonState(button, 'default');
        }, 1300);
      });
  }

  var panelOpener = null;
  var floatingFrame = 0;
  function updateFloatingFilter() {
    if (!floatingButton) return;
    var toolbar = root.querySelector('.dlt-grid__toolbar');
    var otherModal = Array.prototype.some.call(document.querySelectorAll('[aria-modal="true"]:not([aria-hidden="true"]), cart-drawer[open]'), function(el) { return el !== panel && el.getClientRects().length > 0; });
    var visible = isMobile() && toolbar && toolbar.getBoundingClientRect().bottom <= 0 && section.getBoundingClientRect().bottom > 160 && !otherModal;
    floatingButton.hidden = !visible;
  }
  function scheduleFloatingFilter() {
    if (floatingFrame) return;
    floatingFrame = window.requestAnimationFrame(function() { floatingFrame = 0; if (!signal.aborted) updateFloatingFilter(); });
  }
  signal.addEventListener('abort', function() { if (floatingFrame) window.cancelAnimationFrame(floatingFrame); }, { once: true });
  scheduleFloatingFilter();

  function openPanel() {
    if (!panel) return;

    panelOpener = document.activeElement;
    if (isMobile()) { panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); }
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');

    if (filterButton) {
      filterButton.classList.add('is-active');
      filterButton.setAttribute('aria-expanded', 'true');
    }

    if (floatingButton) {
      floatingButton.setAttribute('aria-expanded', 'true');
    }

    if (backdrop) {
      backdrop.classList.add('is-visible');
    }

    if (isMobile()) {
      document.documentElement.classList.add(lockClass);
      document.body.classList.add(lockClass);

      window.setTimeout(function () {
        if (panelClose && panel.classList.contains('is-open')) panelClose.focus({ preventScroll: true });
      }, 120);
    }
  }

  function closePanel() {
    if (!panel) return;

    panel.classList.remove('is-open');
    var wasOpen = panel.classList.contains('is-open') || panel.getAttribute('aria-hidden') === 'false';
    panel.setAttribute('aria-hidden', 'true');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    if (wasOpen && panelOpener && panelOpener.isConnected) panelOpener.focus({ preventScroll: true });

    if (filterButton) {
      filterButton.classList.remove('is-active');
      filterButton.setAttribute('aria-expanded', 'false');
    }

    if (floatingButton) {
      floatingButton.setAttribute('aria-expanded', 'false');
    }

    if (backdrop) {
      backdrop.classList.remove('is-visible');
    }

    document.documentElement.classList.remove(lockClass);
    document.body.classList.remove(lockClass);
  }

  function togglePanel(forceOpen) {
    if (!panel) return;

    var shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : !panel.classList.contains('is-open');

    if (shouldOpen) {
      openPanel();
    } else {
      closePanel();
    }
  }

  [filterButton, floatingButton].forEach(function (button) {
    if (!button) return;

    button.addEventListener('click', function () {
      togglePanel();
    }, { signal: signal });
  });

  if (panelClose) {
    panelClose.addEventListener('click', closePanel, { signal: signal });
  }

  if (applyButton) {
    applyButton.addEventListener('click', function () {
      closePanel();

      if (isMobile() && grid) {
        grid.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    }, { signal: signal });
  }

  if (backdrop) {
    backdrop.addEventListener('click', closePanel, { signal: signal });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab' && isMobile() && panel && panel.classList.contains('is-open')) {
      var focusable = Array.prototype.filter.call(panel.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'), function(el) { return el.getClientRects().length > 0; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (first && event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (last && !event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
    if (event.key === 'Escape' && panel && panel.classList.contains('is-open')) {
      closePanel();
    }
  }, { signal: signal });

  var emptyClear = root.querySelector('[data-dlt-grid-clear-empty]');
  if (emptyClear && clearButton) emptyClear.addEventListener('click', function() { clearButton.click(); }, { signal: signal });

  function getSortValue() {
    return normalizeSortValue(currentSortValue);
  }

  function setSortValue(value, triggerRender) {
    var normalizedValue = normalizeSortValue(value);
    currentSortValue = normalizedValue;

    sortSelects.forEach(function (select) {
      if (!select) return;

      var hasOption = Array.prototype.slice.call(select.options || []).some(function (option) {
        return option.value === normalizedValue;
      });

      select.value = hasOption ? normalizedValue : 'popular';
    });

    if (triggerRender !== false) {
      render(true);
    }
  }

  function getGroupValues(group) {
    return Array.isArray(filters[group]) ? filters[group] : [];
  }

  function activeFilterCount() {
    return filters.active.length + filters.skin.length + (filters.price ? 1 : 0) + (filters.availability ? 1 : 0);
  }

  function getFilterLabel(group, value) {
    if (group === 'availability') {
      return value === 'available' ? 'Em estoque' : 'Oferta';
    }

    if (group === 'price') {
      var priceMap = {
        '0-10000': 'Até R$100',
        '10001-20000': 'R$100–R$200',
        '20001-35000': 'R$200–R$350',
        '35001-99999999': 'Acima de R$350'
      };

      return priceMap[value] || value;
    }

    var tag = filterControls.find(function (item) {
      return item.getAttribute('data-dlt-filter-group') === group && item.getAttribute('data-dlt-filter-value') === value;
    });

    return tag ? tag.textContent.replace(/\(\d+\)/g, '').replace('✓', '').trim() : value;
  }

  function toggleFilter(group, value) {
    if (!group) return;

    if (group === 'active' && value === 'all') {
      filters.active = [];
      render(true);
      return;
    }

    if (group === 'active' || group === 'skin') {
      var list = getGroupValues(group).slice();
      var index = list.indexOf(value);

      if (index === -1) {
        list.push(value);
      } else {
        list.splice(index, 1);
      }

      filters[group] = list;
      render(true);
      return;
    }

    filters[group] = filters[group] === value ? null : value;
    render(true);
  }

  function syncFilterButtons() {
    filterControls.forEach(function (button) {
      var group = button.getAttribute('data-dlt-filter-group');
      var value = button.getAttribute('data-dlt-filter-value');
      var active = false;

      if (value === 'all' && group === 'active') {
        active = filters.active.length === 0;
      } else if (group === 'active' || group === 'skin') {
        active = getGroupValues(group).indexOf(value) !== -1;
      } else {
        active = filters[group] === value;
      }

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateActivePills() {
    if (!activePills) return;

    activePills.innerHTML = '';

    function addPill(group, value) {
      var label = getFilterLabel(group, value);
      var pill = document.createElement('span');
      pill.className = 'dlt-grid__active-pill';
      pill.textContent = label + ' ';

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '×';
      remove.setAttribute('aria-label', 'Remover filtro ' + label);
      remove.setAttribute('data-dlt-active-pill-remove', '');
      remove.setAttribute('data-dlt-filter-group', group);
      remove.setAttribute('data-dlt-filter-value', value);

      pill.appendChild(remove);
      activePills.appendChild(pill);
    }

    filters.active.forEach(function (value) { addPill('active', value); });
    filters.skin.forEach(function (value) { addPill('skin', value); });

    if (filters.price) addPill('price', filters.price);
    if (filters.availability) addPill('availability', filters.availability);

    var count = activeFilterCount();

    if (clearButton) {
      clearButton.style.display = count ? 'inline-flex' : 'none';
    }

    if (floatingCount) {
      floatingCount.textContent = count;
      floatingCount.hidden = count === 0;
    }
  }

  function itemMatches(item, override) {
    var data = getItemData(item);
    var activeValues = override && override.group === 'active' ? [override.value] : filters.active;
    var skinValues = override && override.group === 'skin' ? [override.value] : filters.skin;
    var priceValue = override && override.group === 'price' ? override.value : filters.price;
    var availabilityValue = override && override.group === 'availability' ? override.value : filters.availability;

    if (availabilityValue === 'available' && !data.available) return false;
    if (availabilityValue === 'on-sale' && !data.onSale) return false;

    if (activeValues.length) {
      var hasActive = activeValues.some(function (value) {
        return data.active.has(value);
      });

      if (!hasActive) return false;
    }

    if (skinValues.length) {
      var hasSkin = skinValues.some(function (value) {
        return data.skin.has(value);
      });

      if (!hasSkin) return false;
    }

    if (priceValue) {
      var range = priceValue.split('-');
      var min = parseInt(range[0], 10) || 0;
      var max = parseInt(range[1], 10) || 999999999;

      if (data.price < min || data.price > max) return false;
    }

    return true;
  }

  function updateCounts() {
    var counts = Object.create(null);

    function countFor(group, value) {
      var key = group + ':' + value;
      if (Object.prototype.hasOwnProperty.call(counts, key)) return counts[key];

      var count = 0;
      for (var i = 0; i < originalOrder.length; i += 1) {
        if (itemMatches(originalOrder[i], { group: group, value: value })) count += 1;
      }

      counts[key] = count;
      return count;
    }

    countControls.forEach(function (counter) {
      var token = counter.getAttribute('data-dlt-count-for') || '';
      var parts = token.split(':');
      var group = parts[0];
      var value = parts[1];

      if (!group || !value) return;

      var count = countFor(group, value);
      var nextText = count ? '(' + count + ')' : '';
      if (counter.textContent !== nextText) counter.textContent = nextText;
    });

    filterControls.forEach(function (button) {
      var group = button.getAttribute('data-dlt-filter-group');
      var value = button.getAttribute('data-dlt-filter-value');

      if (!group || !value || value === 'all') return;

      var count = countFor(group, value);
      var disabled = count === 0;
      button.classList.toggle('is-disabled', disabled);
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function sortItems(items) {
    var sortValue = getSortValue();
    var sorted = items.slice();

    if (sortValue === 'price-asc') {
      sorted.sort(function (a, b) {
        return getItemData(a).price - getItemData(b).price;
      });
    } else if (sortValue === 'price-desc') {
      sorted.sort(function (a, b) {
        return getItemData(b).price - getItemData(a).price;
      });
    } else if (sortValue === 'discount') {
      sorted.sort(function (a, b) {
        return getItemData(b).discount - getItemData(a).discount;
      });
    } else if (sortValue === 'az') {
      sorted.sort(function (a, b) {
        return getItemData(a).title.localeCompare(getItemData(b).title, 'pt-BR');
      });
    }

    return sorted;
  }

  function getOrderedItems() {
    var sortValue = getSortValue();

    if (orderedItemsCache && orderedItemsSortValue === sortValue) {
      return orderedItemsCache;
    }

    var available = [];
    var unavailable = [];

    originalOrder.forEach(function (item) {
      (getItemData(item).available ? available : unavailable).push(item);
    });

    orderedItemsCache = sortItems(available).concat(sortItems(unavailable));
    orderedItemsSortValue = sortValue;

    return orderedItemsCache;
  }

  function renderNow(shouldUpdateUrl) {
    var sortValue = getSortValue();
    var orderedItems = getOrderedItems();
    var sorted = orderedItems.filter(function (item) {
      return itemMatches(item);
    });
    var visibleSet = new Set(sorted);

    items.forEach(function (item) {
      var shouldHide = !visibleSet.has(item);
      if (item.classList.contains('is-hidden') !== shouldHide) {
        item.classList.toggle('is-hidden', shouldHide);
      }
    });

    /*
      Reordering the whole grid is only required when the selected sort changes.
      Filter changes now toggle visibility in place, avoiding a full detach/append
      cycle for every visible product on each interaction.
    */
    if (domOrderSortValue !== sortValue) {
      var fragment = document.createDocumentFragment();
      orderedItems.forEach(function (item) {
        fragment.appendChild(item);
      });
      grid.appendChild(fragment);
      domOrderSortValue = sortValue;
    }

    var countText = sorted.length + ' produto' + (sorted.length === 1 ? '' : 's');
    countEls.forEach(function (countEl) {
      if (countEl.textContent !== countText) countEl.textContent = countText;
    });

    if (emptyEl) {
      emptyEl.classList.toggle('is-visible', sorted.length === 0);
    }

    syncFilterButtons();
    updateActivePills();
    scheduleCounts();

    if (shouldUpdateUrl) {
      updateUrlState();
    }
  }

  function scheduleCounts() {
    if (countIdleHandle) {
      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(countIdleHandle);
      } else {
        window.clearTimeout(countIdleHandle);
      }
    }

    var run = function () {
      countIdleHandle = 0;
      updateCounts();
    };

    if ('requestIdleCallback' in window) {
      countIdleHandle = window.requestIdleCallback(run, { timeout: 240 });
    } else {
      countIdleHandle = window.setTimeout(run, 80);
    }
  }

  function scheduleRender(shouldUpdateUrl) {
    pendingRenderUpdateUrl = pendingRenderUpdateUrl || !!shouldUpdateUrl;
    if (renderFrame) return;

    renderFrame = window.requestAnimationFrame(function () {
      var updateUrl = pendingRenderUpdateUrl;
      renderFrame = 0;
      pendingRenderUpdateUrl = false;
      renderNow(updateUrl);
    });
  }

  function render(shouldUpdateUrl, immediate) {
    if (immediate === true) {
      renderNow(shouldUpdateUrl);
      return;
    }

    scheduleRender(shouldUpdateUrl);
  }

  root.addEventListener('click', function (event) {
    var tooltipTrigger = getTooltipTrigger(event.target);

    if (tooltipTrigger && isMobile() && !tooltipTrigger.matches('a[href]')) {
      event.preventDefault();

      if (
        activeTooltipTrigger === tooltipTrigger &&
        tooltipLayer &&
        tooltipLayer.classList.contains('is-visible')
      ) {
        hideTooltip(0);
      } else {
        showTooltip(tooltipTrigger);
      }
      return;
    }

    var pillRemove = event.target.closest('[data-dlt-active-pill-remove]');
    if (pillRemove && activePills && activePills.contains(pillRemove)) {
      var pillGroup = pillRemove.getAttribute('data-dlt-filter-group');
      var pillValue = pillRemove.getAttribute('data-dlt-filter-value');

      if (pillGroup === 'active' || pillGroup === 'skin') {
        filters[pillGroup] = getGroupValues(pillGroup).filter(function (item) {
          return item !== pillValue;
        });
      } else if (pillGroup) {
        filters[pillGroup] = null;
      }

      render(true);
      return;
    }

    var filterTrigger = event.target.closest('[data-dlt-filter-group]');

    if (filterTrigger) {
      var group = filterTrigger.getAttribute('data-dlt-filter-group');
      var value = filterTrigger.getAttribute('data-dlt-filter-value');

      if (filterTrigger.getAttribute('aria-disabled') === 'true' && !filterTrigger.classList.contains('is-active')) {
        return;
      }

      filterTrigger.classList.toggle('is-active');
      filterTrigger.setAttribute(
        'aria-pressed',
        filterTrigger.classList.contains('is-active') ? 'true' : 'false'
      );
      toggleFilter(group, value);
      return;
    }

    var wishlistButton = event.target.closest('[data-dlt-wishlist]');
    if (wishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistButton);
      return;
    }

    var addButton = event.target.closest('[data-dlt-add]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addToCart(addButton);
    }
  }, { signal: signal });

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      filters = { active: [], skin: [], price: null, availability: null };
      render(true);
    }, { signal: signal });
  }

  sortSelects.forEach(function (select) {
    if (!select) return;

    var handleSortChange = function () {
      setSortValue(select.value, true);

      if (grid) {
        grid.setAttribute('aria-busy', 'true');
        window.setTimeout(function () {
          grid.removeAttribute('aria-busy');
        }, 160);
      }
    };

    select.addEventListener('change', handleSortChange, { signal: signal });
  });

  window.addEventListener('resize', function () {
    if (resizeFrame) return;

    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = 0;
      updateFloatingFilter();

      if (panel && panel.classList.contains('is-open')) {
        document.documentElement.classList.toggle(lockClass, isMobile());
        document.body.classList.toggle(lockClass, isMobile());
        if (isMobile()) { panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); }
        else { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); }
      }

      if (activeTooltipTrigger) {
        positionTooltip(activeTooltipTrigger);
      }
    });
  }, { signal: signal });

  if (tooltipLayer) {
    window.addEventListener('scroll', function () {
      scheduleFloatingFilter();
      if (activeTooltipTrigger) hideTooltip(0);
    }, { passive: true, signal: signal });
  }

  window.addEventListener('dlt:wishlist-updated', syncWishlist, { signal: signal });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncWishlist();
  }, { signal: signal });


  /*
    Avaliações v43:
    renderizadas exclusivamente no Liquid a partir do badge Judge.me.
    Não há fetch da PDP, parsing de HTML ou cache de notas no navegador.
  */

  hydrateFromUrl();
  syncWishlist();
  render(false, true);
  }

  function initAll(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    if (base.matches && base.matches('.section--dlt-grid-colecao-premium')) init(base);
    Array.prototype.forEach.call(base.querySelectorAll('.section--dlt-grid-colecao-premium'), init);
  }

  window.DLTCollectionGridRuntime = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.matches && event.target.matches('.section--dlt-grid-colecao-premium')
      ? event.target
      : null;
    if (root && root.__dltGridAbortController) {
      root.__dltGridAbortController.abort();
      root.__dltGridAbortController = null;
    }
  });
})();
